import React from 'react';

import { NEW_LINE_CHARACTERS } from 'src/constants/Generals';
import { Section } from 'jbc-front/components/Form';
import styles from './ErrorsSection.scss';
import { withTranslation } from 'react-i18next';

const ErrorItem = ({ error }) => <li className={styles.error}>{error}</li>;

class ErrorsSection extends React.Component {
  render() {
    const { errors, title = this.props.t('components.ErrorsSection.Please_check_the_following_errors') } = this.props;
    return (
      <div>
        {errors &&
          errors.length > 0 && (
            <Section title={title} error>
              <ul className="u-mb20">
                {errors.map(error => error.split(NEW_LINE_CHARACTERS).map(err => <ErrorItem key={err} error={err} />))}
              </ul>
            </Section>
          )}
      </div>
    );
  }
}

export default withTranslation()(ErrorsSection);
